import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'

import type { NoteSchema } from './types/Note.schema'

export type PostNoteOptions = QueryFnParams<{
  payload: Partial<NoteSchema>
}>

export const postNote = async (opts: PostNoteOptions) => {
  const response = await httpServices.core.post(`/daily_notes`, opts.payload)
  return response.data
}

export type PutNoteOptions = QueryFnParams<{
  pathParams: { id: number }
  payload: Partial<NoteSchema>
}>

export const putNote = async (opts: PutNoteOptions) => {
  const response = await httpServices.core.put(
    `/daily_notes/${opts?.pathParams.id}`,
    opts.payload
  )
  return response.data
}

export type DeleteNoteOptions = QueryFnParams<{
  pathParams: { id: number }
}>
export const deleteNote = async (opts: DeleteNoteOptions) => {
  const response = await httpServices.core.delete(
    `/daily_notes/${opts?.pathParams.id}`
  )
  return response.data
}
